export default {
  noResults: 'No results',
};



// WEBPACK FOOTER //
// ./src/widgets/refinement-list/defaultTemplates.searchForFacetValue.js